module.exports = __webpack_public_path__ + "img/memoir_rings@2x.97625bd.jpg";